import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped
import { getPortalScopesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
export const _fetchPortalScopes = () => http.get(`hubs2/v1/scopes/hub/${PortalIdParser.get()}`);
export const getPortalScopes = () => getFromEarlyRequest(getPortalScopesKey(), () => _fetchPortalScopes());